import React from "react";
import { links } from "../lib/data";

function ResumeSection() {
  return (
    <div className="opacity-0-start animate-fade-in-d1 flex flex-col items-center gap-6 text-center pt-10">
      <div className="w-16 h-16 rounded-xl bg-accent-dim flex items-center justify-center text-3xl">
        ↓
      </div>

      <h2 className="text-xl font-bold">Download Resume</h2>

      <p className="text-base text-content-muted max-w-sm">
        Get a detailed overview of my qualifications, experience, and skills.
      </p>

      <div className="flex gap-3">
        <a
          href={links.resume}
          download
          className="inline-flex items-center gap-2 px-7 py-3 rounded-lg text-base font-semibold no-underline text-bg bg-accent hover:-translate-y-0.5 hover:shadow-glow transition-all duration-150"
        >
          Download PDF
        </a>
        <a
          href={links.resume}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-7 py-3 rounded-lg text-base font-medium no-underline text-content bg-bg-raised border border-border hover:border-accent transition-all duration-150"
        >
          View in Browser
        </a>
      </div>
    </div>
  );
}

export default ResumeSection;